module.exports = __webpack_public_path__ + "img/ic_feedback.a3ed00e4.png";